import { TR } from '@/i18n/i18n-global'

import { SurveyData } from './types'

export const getSurveyQuestion = (tr: TR): SurveyData[] => [
    {
        questionText: 'Did you like the game?',
        questionId: 'like_game',
        question: tr('modalSurvey.like_game'),
        options: [
            {
                selectedOption: tr('modalSurvey.like_game_answer1'),
                selectedOptionText: 'yes',
                selectedOptionId: 'yes',
                icon: 'heart',
            },
            {
                selectedOption: tr('modalSurvey.like_game_answer2'),
                selectedOptionText: 'ok',
                selectedOptionId: 'ok',
                icon: 'smile',
            },
            {
                selectedOption: tr('modalSurvey.like_game_answer3'),
                selectedOptionText: 'no',
                selectedOptionId: 'no',
                icon: 'poop',
            },
        ],
    },
    {
        question: tr('modalSurvey.recommend_game'),
        questionId: 'recommend_game',
        questionText: 'Would you recommend it to a friend?',
        options: [
            {
                selectedOption: tr('modalSurvey.recommend_game_answer1'),
                selectedOptionText: 'yes',
                selectedOptionId: 'yes',
                icon: 'heart',
            },
            {
                selectedOption: tr('modalSurvey.recommend_game_answer2'),
                selectedOptionText: 'maybe',
                selectedOptionId: 'maybe',
                icon: 'smile',
            },
            {
                selectedOption: tr('modalSurvey.recommend_game_answer3'),
                selectedOptionText: 'no',
                selectedOptionId: 'no',
                icon: 'poop',
            },
        ],
    },
    {
        question: tr('modalSurvey.game_problems'),
        questionId: 'game_problems',
        questionText: 'Did you run into any problems?',
        options: [
            {
                selectedOption: tr('modalSurvey.game_problems_answer1'),
                selectedOptionText: 'no',
                selectedOptionId: 'no',
                icon: 'heart',
            },
            {
                selectedOption: tr('modalSurvey.game_problems_answer2'),
                selectedOptionText: 'minor bugs',
                selectedOptionId: 'minor',
                icon: 'smile',
            },
            {
                selectedOption: tr('modalSurvey.game_problems_answer3'),
                selectedOptionText: 'yes',
                selectedOptionId: 'yes',
                icon: 'poop',
            },
        ],
    },
    {
        question: tr('modalSurvey.how_long_play'),
        questionId: 'how_long_play',
        questionText: 'How long did you play?',
        options: [
            {
                selectedOption: tr('modalSurvey.how_long_play_answer1'),
                selectedOptionText: 'less 5 min',
                selectedOptionId: '5_min',
            },
            {
                selectedOption: tr('modalSurvey.how_long_play_answer2'),
                selectedOptionText: '5-20 min',
                selectedOptionId: '5-20_min',
            },
            {
                selectedOption: tr('modalSurvey.how_long_play_answer3'),
                selectedOptionText: 'more 20 min',
                selectedOptionId: 'more_20_min',
            },
        ],
    },
    {
        question: tr('modalSurvey.game_graphic'),
        questionId: 'game_graphic',
        questionText: 'How did you like the graphics?',
        options: [
            {
                selectedOption: tr('modalSurvey.game_graphic_answer1'),
                selectedOptionText: 'awesome',
                selectedOptionId: 'awesome',
                icon: 'heart',
            },
            {
                selectedOption: tr('modalSurvey.game_graphic_answer2'),
                selectedOptionText: 'decent',
                selectedOptionId: 'decent',
                icon: 'smile',
            },
            {
                selectedOption: tr('modalSurvey.game_graphic_answer3'),
                selectedOptionText: 'not great',
                selectedOptionId: 'not_great',
                icon: 'poop',
            },
        ],
    },
]
